var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"block"},[_c('transition',{attrs:{"name":"r-block"}},[(_vm.show)?_c('div',{staticClass:"r-block r-clearfix",class:[
        {
          'r-block-border-top': _vm.isBorderTop,
          'r-block-border-right': _vm.isBorderRight,
          'r-block-border-bottom': _vm.isBorderBottom,
          'r-block-border-left': _vm.isBorderLeft
        }
      ]},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d06561d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/r-elements/RBlock.vue
// module id = null
// module chunks = 